import { Link } from 'react-router-dom'
import { CreditCard } from 'lucide-react'

export function Billing() {
  return (
    <div className="min-h-screen bg-black text-white">
      <section className="relative max-w-5xl mx-auto px-6 py-16">
        <div className="absolute inset-0 bg-gradient-to-b from-[#050309] via-black to-black -z-10" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_0,rgba(212,175,55,0.18),transparent_55%),radial-gradient(circle_at_100%_100%,rgba(74,31,184,0.35),transparent_55%)] -z-10" />

        <div className="flex items-center justify-between gap-4 mb-10">
          <Link to="/" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">
            &larr; Back to home
          </Link>
        </div>

        <header className="mb-10">
          <p className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-3 py-1 text-xs font-medium text-[#FFD700] mb-4">
            <CreditCard className="w-4 h-4" />
            Subscription & payments
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#D4AF37] via-[#FFFFFF] to-[#D4AF37] bg-clip-text text-transparent">
            Billing
          </h1>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl">
            Manage your subscription and payment methods. This section is coming soon.
          </p>
        </header>

        <div className="p-6 rounded-xl bg-gradient-to-br from-gray-900 to-black border border-gray-800 max-w-xl">
          <p className="text-gray-400 text-sm">
            You will be able to update your plan, add a payment method, and view billing history here.
          </p>
          <Link to="/" className="inline-block mt-4 text-sm font-medium text-[#D4AF37] hover:text-[#FFD700] transition-colors">
            Return home
          </Link>
        </div>
      </section>
    </div>
  )
}
